import React, { useEffect, useRef, useState } from 'react';
import { SatelliteImageTask } from '../../models/satellite';
import StandardPage from '../../components/StandardPage';
import { useAuth0 } from '@auth0/auth0-react';
import { toast } from 'react-toastify';
import { SatelliteImageRequestTable } from '../../components/Satellite/SatelliteImageRequestTable';
import { handleApiError } from '../../api-client/error_handler';
import axios from 'axios';
import { trackSatelliteAdminRefresh } from '../../analytics';

export default function TasksForAdmin() {
  const [results, setResults] = useState<SatelliteImageTask[]>([]);
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const abortControllerRef = useRef<AbortController | null>(null);

  const fetchTasks = async () => {
    setLoading(true);
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    try {
      const token = await getAccessTokenSilently();
      const { data: { tasks } } = await axios.get(process.env.REACT_APP_API_BASE_URL + `/satellite/get-tasks-for-admin`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        signal: abortController.signal
      });
      setResults(tasks);
    } catch (err) {
      const error = err as Error;
      if (error.name !== 'AbortError' && (err as any).code !== 'ERR_CANCELED') {
        toast.error(handleApiError(err));
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const handleRefreshTasks = () => {
    trackSatelliteAdminRefresh();
    fetchTasks();
  };

  return (
    <StandardPage title='All Tasks'>
      <div className="p-6">
        <div className="flex justify-end mb-4">
          <button
            onClick={handleRefreshTasks}
            disabled={loading}
            className={`bg-gradient-to-r from-blue-500 to-blue-700 text-white px-5 py-3 rounded-full shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all duration-300 ease-in-out flex items-center ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 4v5h1M4 9a9 9 0 0115.364-3.364M20 20v-5h-1M20 15a9 9 0 01-15.364 3.364"
              />
            </svg>
            Refresh
          </button>
        </div>
        <SatelliteImageRequestTable tasks={results} setTasks={setResults} loading={loading} forAdminView />
      </div>
    </StandardPage>
  );
}
